import PropTypes from 'prop-types';
import React from 'react';
import Cx from 'classnames';
import Style from './style.scss';
import { LinkButton } from '../utils/Styled/buttons';
import { Row, Col } from 'react-bootstrap';
import ScFolder from './scFolder';
import ScCategory from './scCategory';
import ScReference from './scReference';
import ScLink from './scLink';
import C from '../../constants/serviceCatalog';

class ScView extends React.Component {
  constructor(props) {
    super(props);
    this.links = [
      C.LINK,
      C.INCIDENT_TEMPLATE_LINK,
      C.REQUEST_TEMPLATE_LINK,
      C.SUBMIT_INCIDENT,
      C.SUBMIT_REQUEST,
      C.FAQ_ITEM
    ];
    //todo: to show showMoreBtn set to max real number;
    this.max = Infinity; //25
  }

  render() {
    const children = this.props.children
      ? this.props.children.map((item, index) => {
          let key = item.id + '_' + index;
          if (item.type === C.FOLDER) {
            return (
              <ScFolder
                key={key}
                {...item}
                handleClick={this.props.updateBranch}
                intlObject={this.props.intlObject}
                reportAnalytics={this.props.reportAnalytics}
              />
            );
          } else if (
            item.type === C.CATEGORY_POINTER ||
            item.type === C.CATEGORY_INFO
          ) {
              return (
                  <ScCategory
                      key={key}
                      {...item}
                      handleClick={this.props.updateBranch}
                      intlObject={this.props.intlObject}
                      reportAnalytics={this.props.reportAnalytics}
                  />
              );
          }else if(item.type === C.REFERENCE){
              return (
                  <ScReference
                      key={key}
                      {...item}
                      handleClick={this.props.updateBranch}
                      intlObject={this.props.intlObject}
                      reportAnalytics={this.props.reportAnalytics}
                  />
              );
          } else if (this.links.includes(item.type)) {
            return (
              <ScLink
                key={key}
                {...item}
                intlObject={this.props.intlObject}
                reportAnalytics={this.props.reportAnalytics}
              />
            );
          }
        })
      : null;
    const showMore =
      this.props.children && this.props.children.length > this.max ? (
        <div className={Style.showMore}>
          <LinkButton bsStyle="link">+show More</LinkButton>
        </div>
      ) : null;

    let items;
    if (this.props.children && this.props.children.length > 0) {
      items = children;
    } else {
      items = (
        <div className={Style.emptyItem}>
          {this.props.intlObject['ssp.toolbox.No.Items']}
        </div>
      );
    }
    return (
      <div>
        <Row>
          <Col lg={12} md={12} className={Cx(Style.flexRow, 'sspScTiles')}>
            {items}
          </Col>
        </Row>
        <Row>
          <Col lg={12} md={12} className="noSidePadding">
            {showMore}{' '}
          </Col>
        </Row>
      </div>
    );
  }
}

ScView.propTypes = {
  children: PropTypes.array,
  intlObject: PropTypes.object.isRequired,
  reportAnalytics: PropTypes.func.isRequired,
  updateBranch: PropTypes.func.isRequired
};
export default ScView;



// WEBPACK FOOTER //
// ./components/ServiceCatalog/scView.js